export class ResourceNotFoundError extends Error {

  constructor(
    message: string = 'Resource not found'
  ) {
    super(message);

    this.name = 'ResourceNotFoundError';

    Object.setPrototypeOf(this, ResourceNotFoundError.prototype);
  }
}

export class BadRequestError extends Error {

  constructor(
    message: string = 'Bad request'
  ) {
    super(message);

    this.name = 'BadRequestError';

    Object.setPrototypeOf(this, BadRequestError.prototype);
  }
}

export class ServerError extends Error {

  constructor(
    message: string = 'Server error'
  ) {
    super(message);

    this.name = 'ServerError';

    Object.setPrototypeOf(this, ServerError.prototype);
  }

}
